var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"town town_header",class:{ town_active: _vm.showCitySelect },attrs:{"id":"cities"}},[_c('a',{staticClass:"town__link",attrs:{"href":"#"},on:{"click":_vm.onCitySelectClick}},[_c('svg',{staticClass:"geo-icon",attrs:{"width":"14px","height":"16px"}},[_c('use',{attrs:{"xlink:href":"#geo"}})]),_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('CitySubmit',{attrs:{"showCityConfirm":_vm.showCityConfirm,"showCitySelect":function () {
      _vm.doShowCitySelect()
    },"submitConfirmCity":function () {
      _vm.confirm();
      _vm.persist();
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }